import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="bg-white py-24 px-4 scroll-mt-10" data-id="element-224">
      <div className="max-w-3xl mx-auto" data-id="element-225">
        <div className="text-center mb-12" data-id="element-226">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-4" data-id="element-227">
            Elegí la opción que es para vos
          </h2>
          <p className="text-xl text-navy/70" data-id="element-228">
            Acceso inmediato y de por vida a todo el material
          </p>
        </div>

        <div className="flex flex-col gap-10" data-id="element-229">
          {/* ORDER BUMP 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-dark rounded-2xl p-8 text-white shadow-soft relative border border-navy-light" data-id="element-230">
            <div className="absolute -top-4 right-6 bg-green-500 text-white font-bold px-4 py-1 rounded-full text-sm shadow-lg" data-id="element-231">
              ✅ OPCIÓN MÁS ELEGIDA
            </div>

            <h3 className="text-2xl font-bold mb-1" data-id="element-232">Método Noches de Paz™</h3>
            <p className="text-sky-light mb-4" data-id="element-233">
              6 Tomos + 3 Bonus · 9 PDFs · Acceso inmediato
            </p>

            <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-sm text-white/80 mb-6" data-id="element-234">
              <span data-id="element-235">📘 Diagnóstico del Sueño</span>
              <span data-id="element-236">📘 Ventanas Perfectas</span>
              <span data-id="element-237">📘 Ritual de Noche</span>
              <span data-id="element-238">📘 Pase a la Cuna</span>
              <span data-id="element-239">📘 Rescate Nocturno</span>
              <span data-id="element-240">📘 Plan 7 Noches</span>
              <span data-id="element-241">🎁 Detector de Bloqueos</span>
              <span data-id="element-242">🎁 Protocolo Madrugada</span>
              <span data-id="element-243">🎁 Traductor de Llanto</span>
            </div>

            <div className="flex items-center justify-between bg-white/5 rounded-lg px-4 py-3 mb-6" data-id="element-244">
              <span className="text-white/50 text-sm line-through" data-id="element-245">
                Valor: $39.990
              </span>
              <span className="text-gold font-bold text-lg" data-id="element-246">Hoy: $19.990</span>
            </div>

            <div className="text-center" data-id="element-247">
              <a href="Link de tu checkout" className="block w-full bg-sky hover:bg-sky-light text-navy text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:scale-105 text-center" data-id="element-248">
                👉 SÍ, QUIERO EL MÉTODO NOCHES DE PAZ™
              </a>
              <p className="text-xs text-white/50 mt-3 flex items-center justify-center gap-1" data-id="element-249">
                <Lock size={12} data-id="element-250" /> Pago seguro · Acceso inmediato · PDF en
                minutos
              </p>
            </div>
          </motion.div>

          {/* SEPARATOR */}
          <div className="text-center text-navy/40 font-bold text-lg" data-id="element-251">ó</div>

          {/* ORDER BUMP 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-gradient-to-br from-navy-dark to-purple-900 rounded-2xl p-8 text-white shadow-premium relative border-2 border-gold" data-id="element-252">
            <div className="absolute -top-4 right-6 bg-gold text-navy font-bold px-4 py-1 rounded-full text-sm shadow-lg" data-id="element-253">
              ⭐ LA DECISIÓN MÁS INTELIGENTE
            </div>

            <h3 className="text-2xl font-bold mb-1" data-id="element-254">
              Método Noches de Paz™ — Edición Completa
            </h3>
            <p className="text-gold font-medium mb-4" data-id="element-255">
              6 Tomos + 3 Bonus + 2 PDFs Extra · 11 PDFs · Acceso inmediato
            </p>

            <p className="text-white/80 text-sm mb-5" data-id="element-256">
              Todo el sistema base + los 2 PDFs que te cubren cuando el plan
              perfecto se rompe: fiebre, dientes, regresiones, viajes y la culpa
              emocional.
            </p>

            <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-sm text-white/80 mb-2" data-id="element-257">
              <span data-id="element-258">📘 Los 6 Tomos completos</span>
              <span data-id="element-259">🎁 Los 3 Bonus incluidos</span>
              <span data-id="element-260">🌟 Noches Difíciles</span>
              <span data-id="element-261">🌟 Dormir Sin Culpa</span>
            </div>

            <p className="text-xs text-white/50 mb-6" data-id="element-262">
              Incluye protocolos para fiebre, dentición, regresiones, viajes,
              reinicio post-pausa, cartas emocionales y declaración de crianza.
            </p>

            <div className="flex items-center justify-between bg-white/10 rounded-lg px-4 py-3 mb-6 border border-gold/20" data-id="element-263">
              <span className="text-white/50 text-sm line-through" data-id="element-264">
                Valor: $59.990
              </span>
              <span className="text-gold font-bold text-xl" data-id="element-265">Hoy: $29.990</span>
            </div>

            <div className="text-center" data-id="element-266">
              <a href="Link de tu checkout" className="block w-full bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy text-xl font-bold py-5 px-8 rounded-xl shadow-[0_0_20px_rgba(212,168,83,0.4)] transition-all transform hover:scale-105 text-center" data-id="element-267">
                👉 SÍ, QUIERO LA EDICIÓN COMPLETA
              </a>
              <p className="text-xs text-white/60 mt-3 font-medium flex items-center justify-center gap-1" data-id="element-268">
                <Lock size={12} data-id="element-269" /> La decisión más inteligente · Pago seguro ·
                Acceso inmediato
              </p>
            </div>
          </motion.div>
        </div>

        {/* COMPARISON TABLE */}
        <div className="mt-16" data-id="element-270">
          <h3 className="text-2xl font-bold text-center text-navy mb-8" data-id="element-271">
            COMPARACIÓN VISUAL
          </h3>
          <div className="bg-white rounded-2xl shadow-soft overflow-hidden border border-soft-gray overflow-x-auto" data-id="element-272">
            <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-273">
              <thead data-id="element-274">
                <tr className="bg-navy text-white text-center" data-id="element-275">
                  <th className="p-3 text-left text-sm" data-id="element-276">Característica</th>
                  <th className="p-3 font-semibold text-sm" data-id="element-277">Pack Base</th>
                  <th className="p-3 font-bold text-gold bg-navy-dark text-sm" data-id="element-278">
                    Edición Completa
                  </th>
                </tr>
              </thead>
              <tbody className="text-navy/80 text-sm" data-id="element-279">
                {[['6 Tomos del método', '✅', '✅'], ['3 Bonus incluidos', '✅', '✅'], ['Protocolo noches difíciles', '❌', '✅'], ['Guía fiebre y dentición', '❌', '✅'], ['Guía de regresiones', '❌', '✅'], ['Protocolo para viajes', '❌', '✅'], ['Reinicio post-pausa', '❌', '✅'], ['PDF anti-culpa', '❌', '✅'], ['Cartas para noches difíciles', '❌', '✅'], ['Declaración de crianza', '❌', '✅']].map((row, i) => <tr key={i} className="border-b border-soft-gray text-center" data-id="element-280">
                    <td className="p-3 text-left font-medium" data-id="element-281">{row[0]}</td>
                    <td className="p-3" data-id="element-282">{row[1]}</td>
                    <td className="p-3 bg-gold/5" data-id="element-283">{row[2]}</td>
                  </tr>)}
                <tr className="font-bold text-base text-center" data-id="element-284">
                  <td className="p-3 text-left" data-id="element-285">Precio</td>
                  <td className="p-3" data-id="element-286">$19.990</td>
                  <td className="p-3 bg-gold/10 text-navy" data-id="element-287">$29.990</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}